<script>
import {BFormTextarea} from 'bootstrap-vue';
import {textareaHeight} from '@/utils/textareaSize';

// Inherit BootstrapVue's model, formatter, validity, focus and native event contract.
// Fixed computed rows disable its competing autosizer; this component owns height.
export default {
    name: 'AppTextarea',
    extends: BFormTextarea,
    computed: {
        computedMinRows() { return 4; },
        computedMaxRows() { return 4; },
        computedStyle() {
            return {height: this.heightInPx, minHeight: '0', maxHeight: 'none',
                resize: 'none', overflowY: 'auto', boxSizing: 'border-box', overflowWrap: 'break-word'};
        }
    },
    mounted() {
        this.$el.addEventListener('input', this.setHeight);
        this.$el.addEventListener('focus', this.setHeight);
        window.addEventListener('resize', this.setHeight);
        this.viewport = window.visualViewport;
        if (this.viewport) this.viewport.addEventListener('resize', this.setHeight);
        if (window.ResizeObserver) {
            this.sizeObserver = new window.ResizeObserver(entries => {
                const width = entries[0].contentRect.width;
                if (width !== this.lastWidth) { this.lastWidth = width; this.setHeight(); }
            });
            this.sizeObserver.observe(this.$el);
        }
    },
    beforeDestroy() {
        cancelAnimationFrame(this.sizeFrame);
        if (this.sizeObserver) this.sizeObserver.disconnect();
        this.$el.removeEventListener('input', this.setHeight);
        this.$el.removeEventListener('focus', this.setHeight);
        window.removeEventListener('resize', this.setHeight);
        if (this.viewport) this.viewport.removeEventListener('resize', this.setHeight);
    },
    methods: {
        setHeight() {
            if (this._isDestroyed || this._isBeingDestroyed || this.sizeFrame) return;
            this.sizeFrame = requestAnimationFrame(() => {
                this.sizeFrame = null;
                const el = this.$el;
                if (!el || !el.getClientRects().length || !el.clientWidth) return;
                const style = window.getComputedStyle(el);
                const number = key => parseFloat(style[key]) || 0;
                const line = number('lineHeight') || number('fontSize') * 1.5;
                const padding = number('paddingTop') + number('paddingBottom');
                const border = number('borderTopWidth') + number('borderBottomWidth');
                const viewport = window.visualViewport ? window.visualViewport.height : window.innerHeight;
                const scroll = el.scrollTop;
                const oldHeight = el.style.height;
                // Measure with a stable scrollbar width so growth cannot oscillate.
                el.style.overflowY = 'scroll';
                el.style.height = '0px';
                const height = textareaHeight(el.scrollHeight, line, padding, border, viewport) + 'px';
                el.style.height = height;
                el.style.overflowY = 'auto';
                el.scrollTop = scroll;
                this.heightInPx = height;
                if (height !== oldHeight) this.$nextTick(() => this.$emit('resized'));
            });
        }
    }
};
</script>
